import { render, staticRenderFns } from "./asider-admin.vue?vue&type=template&id=b6f3e17c&scoped=true&"
import script from "./asider-admin.vue?vue&type=script&lang=js&"
export * from "./asider-admin.vue?vue&type=script&lang=js&"
import style0 from "./asider-admin.vue?vue&type=style&index=0&id=b6f3e17c&scoped=true&lang=css&"
import style1 from "./asider-admin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f3e17c",
  null
  
)

export default component.exports